module.exports = __webpack_public_path__ + "static/img/advantage1.f6c3a543.png";